import { defineStore } from 'pinia';





/*
This store manages User and Account state including the ActiveAccount
It is used in the Account administration page and the header due to it's account switching features.
*/
export interface Notification {
  message: string;
  type: NotificationType;
  notifyTime: number;
}

export enum NotificationType {
  Info,
  Success,
  Warning,
  Error
}




export const useNotifyStore = defineStore('notify', () => {
  const clientConfig  = useClientConfig()
  const toast = ref<ReturnType<typeof useToast>>()
  const notifications = ref<Notification[]>([]);
  const notificationsArchive = ref<Notification[]>([]);


  const showToast = (title: string, description: string) => {
    toast.value?.add({
      title: title,
      description: description,
    })
  }

  const notify = (messageOrError: unknown, type: NotificationType) => {
    let message: string = '';
    if (messageOrError instanceof Error) message = messageOrError.message;
    if (typeof messageOrError === 'string') message = messageOrError;
    const notification: Notification = {
      message,
      type,
      notifyTime: Date.now()
    };
    notifications.value.push(notification);
    showToast('',message)
    setTimeout(removeNotification.bind(this), clientConfig.notifications.timeout, notification);
  };

  const removeNotification = (notification: Notification) => {
    notifications.value = notifications.value.filter(
      n => n.notifyTime != notification.notifyTime
    );
  };

  onMounted(() => {
    toast.value = useToast()
  })

  return {
    notifications,
    notificationsArchive,
    notify,
    removeNotification,
    showToast
  };
});
